import React from 'react';
import { connect } from 'react-redux';
import noop from 'lodash/noop';
import {
  Button,
  Col,
  message,
  Row,
} from 'antd';
import { addAndRule } from '@store/filterContainer/actions';
import featureNames from '@utils/featureToggle/constants';
import { selector as commonSelector } from '@store/common';
import { selector as filterContainerSelector } from '@store/filterContainer';
import { createSelector } from 'reselect';
import FilterRow from './FilterRow';
import AndRow from './AndRow';
import styles from './index.less';

class FilterRuleGroup extends React.PureComponent {
  render() {
    return (
      <>
        {this.renderFilterRules()}
        <Row gutter={16}>
          <Col sm={24}>
            <Button className={styles.button} onClick={this.onClickAnd}>
              Add AND Rule
            </Button>
          </Col>
        </Row>
      </>
    );
  }

  onClickAnd = () => {
    const {
      clickAND,
      features,
      andRules,
    } = this.props;
    const ruleLimit = features[featureNames.DRILLDOWN_LIMIT];
    if (andRules.length >= ruleLimit) {
      message.warning(`Reached drilldown limit of ${ruleLimit}`);
      return;
    }
    clickAND();
  };

  renderFilterRules = () => {
    const { rule } = this.props;
    const canDel = rule.length > 1 || rule[0].length > 1;
    const filterRules = rule.map((andRule, idx1) => (
      <Row
        key={`andRule-${idx1}`} // eslint-disable-line react/no-array-index-key
        className={`and-group-${idx1 % 2}`}
      >
        {idx1 !== 0 && <AndRow />}
        {this.renderOrRules(andRule, idx1, canDel)}
      </Row>
    ));
    return filterRules;
  };

  renderOrRules = (andRule, idx1, canDel) => {
    const { dimensions } = this.props;
    return (
      andRule.map((orRule, idx2) => (
        <FilterRow
          key={`${orRule.field}-${idx1}-${idx2}`} // eslint-disable-line react/no-array-index-key
          lookup={`${idx1}-${idx2}`}
          dimensions={dimensions}
          rule={orRule}
          canDel={canDel}
        />
      ))
    );
  }
}

const selector = createSelector(
  commonSelector,
  filterContainerSelector,
  (common, filterStore) => ({
    features: common.features,
    andRules: filterStore.newFilterPanel.rule,
  }),
);

export default connect(
  selector,
  {
    clickAND: addAndRule,
  },
)(FilterRuleGroup);

FilterRuleGroup.defaultProps = {
  clickAND: noop,
};
